module.exports = __webpack_public_path__ + "img/check-mark.1daea6ef.svg";